module.exports = __webpack_public_path__ + "img/draw.95e4862.png";